<template>
    <v-card>
        <v-form ref="form" @submit="submit">
            <v-card-title>
                <v-layout class="title">
                    {{ $i18n.t('newQuestion') }}

                    <v-spacer/>

                    <v-btn @click="$store.commit('setCreateQuestionDialog', false)">
                        {{ $t('cancel') }}
                        <v-icon right>clear</v-icon>
                    </v-btn>
                    <v-btn @click="submit" class="ml-7" color="teal">
                        {{ $t('save') }}
                        <v-icon right>done</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>

            <v-card-text>
                <v-container grid-list-xl>
                    <v-layout col>
                        <v-textarea dense auto-grow rows=1 v-model="getQuestion.text" :rules="textRules" :label="$i18n.t('text')" class="my-n4 headline"/>
                    </v-layout>

                    <v-row align="center">
                        <v-col cols=7>
                            <v-radio-group v-model="correctAnswer">
                                <v-radio v-for="answer in getQuestion.answers" :key="answer.position">
                                    <template v-slot:label>
                                        {{ ['A','B','C','D','E','F','G','H','I','J'][answer.position-1] }}
                                        <v-textarea dense auto-grow rows=1 v-model="answer.text" :rules="answerRules" class="ml-12 body-1 font-weight-light"/>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols=5 order="last" align="center">
                            <v-row>
                                <v-col>
                                    <v-img v-if="!!getQuestion.imageString" :src="getQuestion.imageString" contain height="250px"/>
                                    <v-icon x-large v-else>photo_camera</v-icon>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-file-input v-model="file" @change="encode" outlined dense reverse rounded show-size accept="image/*,.nos" prepend-icon="" :placeholder="$i18n.t('addImage')" style="width: 220px"/>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-divider/>

                    <v-list>
                        <v-list-item>
                            <v-flex xs3 class="subheading font-weight-medium">{{ $i18n.t('title') }}</v-flex>
                            <v-flex>
                                <v-text-field dense v-model="getQuestion.title" :rules="titleRules" :hint="$i18n.t('titleHint')"/>
                            </v-flex>
                        </v-list-item>
                        <v-list-item>
                            <v-flex xs3 class="subheading font-weight-medium">{{ $i18n.t('observations') }}</v-flex>
                            <v-flex>
                                <v-text-field dense v-model="getQuestion.notes" :rules="notesRules" :hint="$i18n.t('notesHint')" class="mt-2"/>
                            </v-flex>
                        </v-list-item>
                        <v-list-item class="mt-n3">
                            <v-flex xs3 class="subheading font-weight-medium">{{ $i18n.t('advanced') }}</v-flex>
                            <v-radio-group v-model="basic" row>
                                <v-radio :label="$i18n.t('yes')"/>
                                <v-radio :label="$i18n.t('no')"/>
                            </v-radio-group>
                        </v-list-item>
                    </v-list>
                </v-container>
            </v-card-text>
        </v-form>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@/main.js' 

export default {
    data(){
        return {
            reader: new FileReader(),
            titleRules: [
                v => !v || v.length <= 1000 || i18n.t('longTitle'),
            ],
            textRules: [
                v => !!v || i18n.t('noText'),
                v => !v || v.length <= 1000 || i18n.t('longText'),
            ],
            answerRules: [
                v => !!v || i18n.t('noAnswer'),
                v => !v || this.getQuestion.answers.filter(answer => answer.text == v).length == 1 || i18n.t('duplicatedAnswer'),
                v => !v || v.length <= 255 || i18n.t('longAnswer'),
            ],
            notesRules: [
                v => !v || v.length <= 1000 || i18n.t('longNotes'),
            ],
        }
    },

    created() {
        this.reader.onloadend = () => { this.getQuestion.imageString = this.reader.result }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate())
                this.$store.dispatch('createQuestion')
        },
        encode(upload) {
            if (!!upload){
                this.reader.readAsDataURL(upload)
                this.getQuestion.image = true
            } else {
                this.getQuestion.imageString = null
                this.getQuestion.image = false
            }
        }
    },

    computed:{
        ...mapGetters([
            'isLoading',
            'getCreateQuestionDialog',
            'getQuestion',
            'getQuestionImage',
            'getFile'
        ]),
        correctAnswer: {
            get() { return this.getQuestion.correctAnswer-1 },
            set(value) { this.getQuestion.correctAnswer = value+1 }
        },
        file: {
            get() { return this.getFile },
            set(value) { this.$store.commit('setFile', value) }
        },
        basic: {
            get() { return this.getQuestion.basic ? 1 : 0 },
            set(value) { this.getQuestion.basic = (value ? true : false) },
        },
    },

    watch: {
        getCreateQuestionDialog() {
            this.$refs.form.resetValidation()
        }
    }
}
</script>

<style>
    .v-textarea textarea {
        line-height: 30px;
    }
</style>
